import React from 'react';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextareaAutosize,
  TextField,
  Typography,
  withStyles,
} from '@material-ui/core';
import moment from 'moment';
import Calendar from 'react-calendar';
import swal from '@sweetalert/with-react';
import axios from 'axios';

import axiosInstance, {
  WEB_API,
  EVENT_ID,
  setScrollPosition,
  addComma,
  checkDeadline,
  focusElementRef,
  getUserID,
  REGISTRAIONSUBMIT_TEMPLATE,
  F_EMAIL,
  BCC_ADDR_EMAIL,
  BCC_ADDR_EMAIL_REG,
  PAYCOMPLETE_TEMPLATE,
  EXIMBAY_MID,
  EXIMBAY_SECRETKEY,
  EXIMBAY_CALLBACK,
  EXIMBAY_STATUS_CALLBACK,
  PG_REDIRECT,
  EXIMBAY_PAY,
  KICC_MID,
  PG_API_URL,
  KICC_PAY,
  KICC_APPROVAL,
  EVENT_IMG,
  readFile,
} from '../constatns';
import {
  EARLY_REGISTRATION_FEE,
  REGULAR_REGISTRATION_FEE,
  ONSITE_REGISTRATION_FEE,
  RESIDENT_TABLE,
  OVERSEA_EARLY_REGISTRATION_FEE,
  OVERSEA_REGULAR_REGISTRATION_FEE,
  OVERSEA_ONSITE_REGISTRATION_FEE,
} from './RegistrationConstants';
import SubTitle from '../components/Text/SubTitle';
import Table from '../components/Table/Table';
import AgreementDiv from '../components/Div/AgreementDiv';
import ConfirmButton from '../components/Button/ConfirmButton';
import querystring from 'querystring';
import Popout from 'react-popout-new';
import Stack from '@mui/material/Stack';
import DocUploadForm from './DocUploadForm';
// import UploadToS3 from '../common/UploadToS3';
// import SocketManager from '../components/SocketManager';
import CircularProgress from '@material-ui/core/CircularProgress';
import UploadToS3Alt from '../common/UploadToS3Alt';

// const { IMP } = window;
const regexp = /\B(?=(\d{3})+(?!\d))/g;
const styles = (theme) => ({
  infoText: {
    color: '#e91e5c',
    fontSize: '1.1em',
    marginTop: theme.spacing(1),
    '& p': {
      textIndent: '-1.1em',
      paddingLeft: '1em',
    },
    '& p:not(:last-child)': {
      marginBottom: theme.spacing(0.5),
    },
  },

  //table
  tableBody1: {
    '& th': {
      width: '15%',
      textAlign: 'center',
      wordBreak: 'keep-all',
    },
    '& td:first-child': {
      width: '85%',
    },
    // '& td:nth-child(n+2)': {
    //   width: '18.333%',
    // },
  },
  tableHeadAlignCenter: {
    '& th': {
      textAlign: 'center',
    },
  },
  tableBodyAlignCenter: {
    '& td': {
      textAlign: 'center',
    },
  },

  tableBorder: {
    '& th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    '& td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },

  cancelInfoDiv: {
    padding: theme.spacing(4, 5),
    border: '2px solid rgb(205, 205, 205)',
    backgroundColor: 'rgba(0, 0, 0, 0.05)',
  },
});

const StyledTableCell = withStyles((theme) => ({
  root: {
    fontSize: '1.3em',
  },
}))(TableCell);

class RegistrationSubmissionForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      now: moment(),

      // language: 'english', 회원확인
      email: '',
      language: '',
      registrationType: '',

      // 회원여부 - 국내
      isMemberChecked: false, //인증 여부
      isMember: false, //정회원 여부
      isFree: false, //무료등록자 여부

      // 등록구분, 결제 요금 및 방법
      selectedFee: '', //등록구분
      registrationFee: 0, //등록비
      annualFee: 0, //국제학회(ICOPLAST) 연회비
      isAnnualPaid: false,
      isAnnualChecked: false,
      journalApplicaitonFee: 0, //학회지(APS)
      isJournalPaid: false,
      isJournalChecked: false,

      freeAps: false,
      freeIco: false,

      // ** PRS 2022 ** dinner 참석여부 (20220708-삭제요청)
      // isDinnerPaid: '', // 저녁식사 참석여부
      // dinnerFee: '', // 저녁식사비

      // totalFee: this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee, //총금액
      paymentMethod: 0,

      // 결제방법 - 은행 송금
      isShowCalendar: false,
      remitterName: '',
      remittanceDate: '',

      // 참가자 동의 확인서
      isAgree: false,
      isAdmin: this.props.isAdmin,
      isMou: false, // 등록자가 MOU 7개국가 인가?
      isUAE: false, // 등록자가 UAE 인가?

      // invited speaker 여부
      invitedSpeaker: [],
      invitedSpeakerCheck: false,

      // 해외등록자 중 추가결제해야하는 사람
      isExtraCharge: false,
      extraCharge: 0,
      paidCharge: 0,

      openPay: false,
      // UAE Trainee 등록관련
      figures: [''], //첨부파일
      isTraineeDoc: false, // UAE Trainee 서류 첨부 여부
      // setOfFigures: 1, //첨부파일 갯수
      attachLoading: false,
    };

    this.receiveMessage = this.receiveMessage.bind(this);
    this.payCallback = this.payCallback.bind(this);
    this.handleAPI = this.handleAPI.bind(this);

    this.refMemberName = React.createRef();
    this.refLicenseNo = React.createRef();
    this.refAgree = React.createRef();
    this.refPaymentMethod = React.createRef();
    this.refRemitterName = React.createRef();
    this.refRemittanceDate = React.createRef();

    this.handleChangeImg = this.handleChangeImg.bind(this);
    this.clickUploadImg = this.clickUploadImg.bind(this);
    this.deleteImg = this.deleteImg.bind(this);
  }

  componentDidMount() {
    window.addEventListener('message', this.receiveMessage);
    setScrollPosition(0);
    if (!sessionStorage.getItem('_in_user_')) {
      this.props.movePage('/signin');
    } else {
      this.setState(
        {
          email: sessionStorage.getItem('_in_user_').split('evt029_')[1],
          language: sessionStorage.getItem('_in_country') === 'Korea, Republic of' ? 'korean' : 'english',
          registrationType:
            // this.props.isRepayment
            //   ? 'regular'
            //   : checkDeadline('regDeadline')
            //   ? 'early'
            //   : checkDeadline('regDeadline2')
            //   ? 'regular'
            //   : 'onsite',

            checkDeadline('regDeadline') ? 'early' : 'regular',
        },
        () => {
          // console.log(this.state.language);
          // console.log(this.state.registrationType);
          this.checkInvitedSpeaker();
          this.init();
        },
      );
    }
  }

  componentWillUnmount() {
    localStorage.removeItem('payResult');
    window.removeEventListener('message', this.receiveMessage);
  }

  receiveMessage(event) {
    if (event.data.payResult) {
      console.log('receiveMessage >>>>');
      if (localStorage.getItem('payResult')) {
        const result = querystring.parse(localStorage.getItem('payResult').replace('?', ''));
        // console.log(result);
        this.payCallback(result);
      } else {
        axiosInstance
          .get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${getUserID()}`, {
            headers: { Pragma: 'no-cache' },
          })
          .then((res) => {
            if (res.data && res.data.Item) {
              if (!this.state.isExtraCharge && res.data.Item.payInfo) {
                // console.log(res.data.Item.payInfo);
                this.payCallback(res.data.Item.payInfo);
              }
              if (this.state.isExtraCharge && res.data.Item.extraPayInfo) {
                this.payCallback(res.data.Item.extraPayInfo);
              }
            }
          });
      }
    }
  }

  checkInvitedSpeaker = () => {
    axiosInstance.get(`${WEB_API}/user/checkEmail?email=${this.state.email}&eventId=evt029`).then((res) => {
      if (res.data && res.data.length > 0) {
        this.setState({ invitedSpeaker: res.data }, () => {
          if (this.state.invitedSpeaker[0].isFree === 'Y') {
            this.setState({ invitedSpeakerCheck: true, selectedFee: 'Invited Speaker' });
          }
        });
      }
    });
  };

  payCallback(result) {
    // console.log('payCallback', result);
    if (this.state.pg === 'eximbay') {
      if (result.rescode === '0000') {
        result['success'] = true;
        this.handleAPI('card', result);
      } else {
        alert(`${this.state.language === 'korean' ? '결제 실패' : 'Payment Failure'}: ${result.resmsg}`);
      }
      localStorage.removeItem('payResult');
    } else if (this.state.pg === 'kicc') {
      const data = {
        mallId: KICC_MID,
        shopTransactionId: result.shopOrderNo,
        authorizationId: result.authorizationId,
        shopOrderNo: result.shopOrderNo,
        approvalReqDate: moment().format('YYYYMMDD'),
      };
      axios.post(KICC_APPROVAL, data).then((res) => {
        // console.log(res);
        if (res.data.resCd === '0000') {
          result['success'] = true;
          this.handleAPI('card', res);
        } else {
          alert(`${this.state.language === 'korean' ? '결제 실패' : 'Payment Failure'}: ${res.data.resMsg}`);
        }
        localStorage.removeItem('payResult');
      });
    }
  }

  handleFee = (e, item) => {
    if (item.category !== 'Invited Speaker') {
      this.setState((prevState) => ({
        selectedFee: item.category,
        registrationFee: item.fee,
      }));
    } else {
      this.setState({
        selectedFee: item.category,
        registrationFee: item.fee,
        invitedSpeakerCheck: true,
      });
    }
  };

  handleState(e, key) {
    this.setState({ [key]: e.target.value });
  }

  handleDate = (val) => {
    this.setState({ remittanceDate: val, isShowCalendar: false });
  };

  init() {
    const userId = this.props.isAdmin ? this.props.userId : getUserID();
    axiosInstance.get(`${WEB_API}/user/info?eventId=${EVENT_ID}&userId=${userId}`).then((response) => {
      // console.log(response.data.Item, 'reg_res');
      if (response && response.data.Item) {
        if (response.data.Item.regType) {
          const rt = response.data.Item.regType;
          // this.setState({ registrationType: rt === 'R1' ? 'early' : rt === 'R2' ? 'regular' : 'onsite' });
          // this.setState({
          //   registrationType: this.props.isRepayment ? 'regular' : rt === 'R1' ? 'early' : rt === 'R2' ? 'regular' : 'onsite',
          // });
        }
        if (
          response.data.Item.status &&
          response.data.Item.status === 'Complete' &&
          (!response.data.Item.isExtraCharge || (response.data.Item.isExtraCharge && response.data.Item?.extraStatus === 'Complete'))
        ) {
          // ** 2022 Custom 등록 결제를 delete로 돌린 경우에도 가입은 가능하게
          if (!this.props.isAdmin && response.data.Item.isPay !== 'C') {
            swal('', 'You already registered.', 'warning');
            this.props.movePage('/');
          }
        }
        if (response.data.Item.isExtraCharge && response.data.Item?.extraStatus !== 'Complete') {
          this.setState({ isExtraCharge: true }, () => {
            swal(
              <div>
                <p style={{ fontSize: '1.2em', marginBottom: '1em' }}>
                  Your registration information is saved properly please pay for difference as follow instruction.
                </p>
                <p>
                  Please check the Participant Release and License Agreement and Payment method only and pay for difference by credit card
                  for registration fee.
                  <br />
                  <b style={{ color: '#f00' }}>(Do not check the registration category!!)</b>
                </p>
              </div>,
              { button: 'Confirm' },
            );
          });
          if (response.data.Item.extraCharge) {
            this.setState(
              {
                registrationFee: response.data.Item.extraCharge,
                extraCharge: response.data.Item.extraCharge,
                paidCharge: response.data.Item.amount,
                regDateBeforeExtraPaid: response.data.Item.regDate,
              },
              () => {
                // console.log('1', this.state.registrationFee);
                // console.log('2', this.state.extraCharge);
                // console.log('3', this.state.paidCharge);
              },
            );
          }
        }
        if (response.data.Item.isDel && response.data.Item.isDel === 1) {
          sessionStorage.removeItem('_in_user_');
          swal('User does not exist.');
          this.props.movePage('/signin');
          return false;
        } else {
          // for ADMIN
          if (this.props.isAdmin) {
            let KR_FEE = this.state.registrationType === 'early' ? EARLY_REGISTRATION_FEE : REGULAR_REGISTRATION_FEE;
            let OVERSEA_FEE = this.state.registrationType === 'early' ? OVERSEA_EARLY_REGISTRATION_FEE : OVERSEA_REGULAR_REGISTRATION_FEE;
            if (this.state.registrationType === 'onsite') {
              KR_FEE = ONSITE_REGISTRATION_FEE;
              OVERSEA_FEE = OVERSEA_ONSITE_REGISTRATION_FEE;
            }
            if (response.data.Item.lang === 'kor') {
              // console.log(KR_FEE);
              // console.log(KR_FEE.find((f) => f.category === response.data.Item.cate1));
              this.setState({
                language: 'korean',
                paymentMethod: response.data.Item.payType === 'bank' ? 'Bank Transfer' : 'Credit Card',
                selectedFee: response.data.Item.cate1,
                registrationFee:
                  response.data.Item.cate1 === '개원의'
                    ? KR_FEE.find((f) => f.category === '전문의').fee
                    : response.data.Item.cate1 !== '개원의' && response.data.Item.cate1 !== '원로회원·기부자·만 70세이상 정회원'
                    ? KR_FEE.find((f) => f.category === response.data.Item.cate1).fee
                    : '',
                isAnnualChecked: response.data.Item.cate3,
                isJournalChecked: response.data.Item.cate4,
                annualFee: response.data.Item.cate3 ? 15000 : 0,
                journalApplicaitonFee: response.data.Item.cate4 ? 20000 : 0,
                remitterName: response.data.Item.depositor,
                remittanceDate: response.data.Item.depositDate,
                isAgree: true,
                memo: response.data.Item.memo,

                //** 2022 CUSTOM DinnerPaid 반영 (20220708-삭제요청)
                // dinnerFee: response.data.Item.isDinner === 'O' ? 30000 : 0,
                // isDinnerPaid: response.data.Item.isDinner === 'O' ? 'O' : 'X',
              });
              if (response.data.Item.cate2) this.setState({ residentType: response.data.Item.cate2 });
            } else {
              this.setState({
                language: 'etc',
                paymentMethod: response.data.Item.payType === 'bank' ? 'Bank Transfer' : 'Credit Card',
                selectedFee: response.data.Item.cate1,
                registrationFee: OVERSEA_FEE.find((f) => f.category === response.data.Item.cate1)
                  ? OVERSEA_FEE.find((f) => f.category === response.data.Item.cate1).fee
                  : '',
                isAgree: true,
                remitterName: response.data.Item.depositor,
                remittanceDate: response.data.Item.depositDate,
                memo: response.data.Item.memo,

                //** 2022 CUSTOM DinnerPaid 반영(20220708 삭제)
                // dinnerFee: response.data.Item.isDinner === 'O' ? 30 : 0,
                // isDinnerPaid: response.data.Item.isDinner === 'O' ? 'O' : 'X',
              });
            }
          } else {
            if (this.state.language === 'korean') {
              this.checkIsMember(response.data.Item);
            } else {
              this.classifyCategoryOversea(response.data.Item);
            }
          }
        }
      }
    });
  }

  //해외 카테고리 자동선택
  classifyCategoryOversea(data) {
    //미국, 일본, 대만, 캐나다, 태국, 인도네시아, 터키
    const allowList = ['United States', 'Japan', 'Taiwan', 'Canada', 'Thailand', 'Indonesia', 'Turkey'];
    for (let i = 0; i < allowList.length; i++) {
      if (data.country.indexOf(allowList[i]) !== -1) {
        this.setState({
          isMou: true,
        });
        break;
      }
      // ** 2022 CUSTOM UAE 등록자 확인
      if (data.country.indexOf('Arab Emirates') !== -1) {
        this.setState({
          isUAE: true,
        });
        break;
      }
    }
  }

  //한국인 협회 회원 확인
  checkIsMember(data) {
    axios.get(`${WEB_API}/user/check?eventId=${EVENT_ID}&username=${data.username}&license=${data.license}`).then((res) => {
      if (res.status === 200 && res.data.length > 0) {
        if (res.data[0].discip === 'Y') {
          // if (res.data[0].memKind.indexOf('징계') !== -1) {
          swal('등록불가한 회원입니다. 사무국으로 문의하시기 바랍니다.', 'error');
          this.props.movePage('/');
        } else {
          this.setState({ isMemberChecked: true }, () => {
            this.checkFeePaid(res.data[0]);
            this.classifyCategory(res.data[0]);
          });
        }
      }
    });
  }

  //회비내야하는지 체크
  checkFeePaid(data) {
    // if (data.icoplast !== 'N') {
    //   this.setState({ isAnnualPaid: true });
    // }
    // if (data.aps !== 'N') {
    //   this.setState({ isJournalPaid: true });
    // }
    if (data.aps === 'Y') {
      this.setState({ freeAps: true });
    }
    if (data.icoplast === 'Y') {
      this.setState({ freeIco: true });
    }
  }

  classifyCategory(data) {
    let selected = '';
    if (data.isFree && data.isFree === 'Y') {
      selected = '원로회원·기부자·만 70세이상 정회원';
      this.setState({ isFree: true, selectedFee: '원로회원·기부자·만 70세이상 정회원', registrationFee: 0 });
    }
  }

  checkValidKorean = () => {
    if (!this.state.isAgree) {
      focusElementRef('참가자 확인 동의서를 숙지 후 동의해주세요.', this.refAgree);
      return false;
    }
    if (this.state.isFree) {
      const am = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;
      if (am === 0) return true;
    }
    if (!this.state.selectedFee) {
      swal('등록구분을 선택해주세요.');
      return false;
    }
    if (!this.state.paymentMethod) {
      focusElementRef('결제수단을 선택해주세요.', this.refPaymentMethod);
      return false;
    }
    if (this.state.paymentMethod && this.state.paymentMethod === 'Bank Transfer') {
      if (!this.state.remitterName) {
        focusElementRef('송금하시는 분의 이름을 입력해주세요.', this.refRemitterName);
        return false;
      }
      if (!this.state.remittanceDate) {
        focusElementRef('송금 예정일을 선택해주세요.', this.refRemittanceDate);
        return false;
      }
    }

    // Gala Dinner Check
    // if (!this.state.isDinnerPaid) {
    //   swal('Gala Dinner 참석 여부를 선택해 주세요.');
    //   document.getElementById('dinner').scrollIntoView();
    //   return false;
    // }
    return true;
  };

  checkValidOversea = () => {
    if (this.state.invitedSpeakerCheck) return true;
    if (!this.state.selectedFee) {
      if (!this.state.isExtraCharge) {
        swal('Please choose Category.');
        return false;
      }
    }
    if (!this.state.isAgree) {
      focusElementRef('Please read agreement content and agree.', this.refAgree);
      return false;
    }
    if (!this.state.paymentMethod) {
      focusElementRef('Please choose payment method.', this.refPaymentMethod);
      return false;
    }
    if (this.state.paymentMethod && this.state.paymentMethod === 'Bank Transfer') {
      if (!this.state.remitterName) {
        focusElementRef(`Please input registrant's name.`, this.refRemitterName);
        return false;
      }
      if (!this.state.remittanceDate) {
        focusElementRef('Please select remittance due date.', this.refRemittanceDate);
        return false;
      }
    }

    // Gala Dinner Check
    // if (!this.state.isDinnerPaid) {
    //   swal('Please choose Gala Dinner Attendance.');
    //   document.getElementById('dinner').scrollIntoView({ block: 'center' });
    //   return false;
    // }
    //International Trainee(UAE)
    if (!this.props.isAdmin && this.state.selectedFee === 'International Trainee(UAE)' && this.state.isTraineeDoc === false) {
      swal('Please attach Document for proof of Resident.');
      document.getElementById('attach').scrollIntoView({ block: 'center' });
      return false;
    }

    return true;
  };

  onSubmit() {
    // const am = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;
    // if (this.state.paymentMethod === 'Bank Transfer' && this.state.selectedFee !== 'International Trainee(UAE)' && am !== 0) {
    //   swal('', 'test', '');
    // }
    // 모바일 등록 제어
    if (
      navigator.userAgent.toLowerCase().indexOf('iphone') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('android') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('mobile') !== -1 ||
      navigator.userAgent.toLowerCase().indexOf('windows phone') !== -1
    ) {
      if (this.state.language === 'korean') {
        swal('사전등록은 PC에서만 가능합니다. (인터넷 익스플로러 제외)');
      } else {
        swal('Early-Bird registration is only available on PC. (Except Internet Explorer)');
      }
    }
    //IE 등록 제어
    else if (navigator.userAgent.toLowerCase().indexOf('trident') !== -1) {
      if (this.state.language === 'korean') {
        swal('사전등록은 인터넷 익스플로러를 제외한 브라우저(ex. 크롬, 사파리, 엣지)에서 가능합니다.');
      } else {
        swal('Early-Bird registration is possible in browsers(ex. Chrome, Edge) other than Internet Explorer.');
      }
    }
    // 등록
    else {
      if (this.state.language === 'korean' ? this.checkValidKorean() : this.checkValidOversea()) {
        const am = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;
        if (
          // this.state.invitedSpeakerCheck ||
          this.state.isFree === true &&
          am === 0
        ) {
          this.handleAPI('무료등록');
        } else if (
          (this.state.paymentMethod === 'Bank Transfer' && this.state.selectedFee !== 'International Trainee(UAE)' && am !== 0) ||
          this.props.isAdmin
        ) {
          this.handleAPI('bank');
        } else if (this.state.selectedFee === 'International Trainee(UAE)' && am === 0) {
          this.handleAPI('UAE_Free');
        } else {
          this.handlePay();
        }
      }
    }
  }

  handlePay() {
    const _pg_ = this.state.language === 'korean' ? 'kicc' : 'eximbay';
    // const _pg_ = 'kicc'; //for test
    this.setState({ pg: _pg_ });

    const amount = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;

    // console.log('card pg: ', _pg_);
    // console.log('card amount: ', amount);
    if (_pg_ === 'eximbay') {
      const data = {
        ver: 230,
        mid: EXIMBAY_MID,
        secretKey: EXIMBAY_SECRETKEY,
        returnurl: EXIMBAY_CALLBACK,
        statusurl: EXIMBAY_STATUS_CALLBACK,
        paymethod: 'P000',
        txntype: 'PAYMENT',
        ostype: 'P',
        displaytype: 'P',
        lang: 'EN',
        param1: PG_REDIRECT,
        cur: 'USD',
        item_0_quantity: '1',
        item_0_unitPrice: '1',
      };

      data['amt'] = '' + amount;
      data['ref'] = `PRS_${new Date().getTime()}`;
      data['buyer'] = sessionStorage.getItem('_in_name');
      data['email'] = sessionStorage.getItem('_in_user_').replace(EVENT_ID + '_', '');
      // data['item_0_product'] = 'PRS KOREA 2021 Registration';
      data['item_0_product'] = 'PRS KOREA 2022 Registration';

      // console.log(data);
      // this.setState({ openPay: true, openPayUrl: EXIMBAY_PAY + '?' + querystring.stringify(data) });
      window.open(EXIMBAY_PAY + '?' + querystring.stringify(data), 'pay', 'width= 400, height= 600');
    } else {
      const data = {
        mallId: KICC_MID,
        payMethodTypeCode: '11',
        currency: '00',
        clientTypeCode: '00',
        returnUrl: PG_API_URL + '/kicc/callback',
        shopValueInfo: {
          value1: PG_REDIRECT,
        },
        deviceTypeCode: 'pc',
        // amount: 100, //test
        amount: amount,
        shopOrderNo: `PRS_${new Date().getTime()}`,
        orderInfo: {
          // goodsName: 'PRS KOREA 2021 Registration',
          goodsName: 'PRS KOREA 2022 Registration',
          // customerInfo: {
          //   customerId: sessionStorage.getItem('_in_user_'),
          //   customerName: sessionStorage.getItem('_in_name'),
          // },
        },
      };
      axios.post(KICC_PAY, data).then((res) => {
        // console.log(res);
        // this.setState({ openPay: true, openPayUrl: res.data.authPageUrl });
        window.open(res.data.authPageUrl, 'pay', 'width= 400, height= 600');
      });
    }
  }

  //API 통신 작업
  handleAPI = function (method, response) {
    const userId = this.props.isAdmin ? this.props.userId : getUserID(true);
    let param = {
      evt: EVENT_ID,
      userId: userId,
      lang: this.state.language === 'korean' ? 'kor' : 'etc',
      // param['amount'] = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee + this.state.dinnerFee;
      // amount: this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee,
      // payType: this.state.paymentMethod === 'Bank Transfer' ? 'bank' : 'card',
      // status: this.state.paymentMethod === 'Bank Transfer' ? 'Wait' : 'Complete',
      // regType: this.state.registrationType === 'early' ? 'R1' : 'R2',
      // cate1: this.state.selectedFee,
      // isDinner: this.state.isDinnerPaid,
    };

    if (this.state.residentType) param['cate2'] = this.state.residentType;
    if (!this.state.isAnnualPaid) param['cate3'] = this.state.isAnnualChecked;
    if (!this.state.isJournalPaid) param['cate4'] = this.state.isJournalChecked;
    // 무료등록
    if (method === '무료등록') {
      param['payCheckDate'] = moment().format('YYYY-MM-DD HH:mm:ss');
      param['payType'] = '무료등록';
      param['status'] = 'Complete';
      // param['payType'] = 'bank';
      // param['status'] = 'Complete';
    }
    // UAE Trainee 무료
    if (method === 'UAE_Free' && this.state.selectedFee === 'International Trainee(UAE)' && this.state.figures[0]) {
      param['payCheckDate'] = moment().format('YYYY-MM-DD HH:mm:ss');
      param['payType'] = '무료등록';
      param['status'] = 'Complete';
      param['attach'] = this.state.figures && getUserID() + '_' + this.state.figures[0].name;
      // param['payType'] = 'bank';
    }

    // 해당 페이지 관리자 페이지에서 열때
    if (this.props.isAdmin) {
      param['memo'] = this.state.memo;
      param['amount'] = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;
      param['payType'] = this.state.paymentMethod === 'Bank Transfer' ? 'bank' : 'card';
    }

    // 해당 페이지 등록 페이지에서 열때
    if (!this.props.isAdmin) {
      if (this.state.isExtraCharge) {
        param['extraPaidAmount'] = this.state.registrationFee;
        param['extraPayType'] = this.state.paymentMethod === 'Bank Transfer' ? 'bank' : 'card';
        param['extraStatus'] = this.state.paymentMethod === 'Bank Transfer' ? 'Wait' : 'Complete';
        // param['amount'] = this.state.registrationFee + this.state.paidCharge;
        param['regDateBeforeExtraPaid'] = this.state.regDateBeforeExtraPaid;
        param['regType'] = 'R1';
      } else {
        param['amount'] = this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee;
        param['payType'] = this.state.paymentMethod === 'Bank Transfer' ? 'bank' : 'card';
        param['status'] =
          //   this.state.paymentMethod === 'Bank Transfer' &&this.state.selectedFee !== 'International Trainee(UAE)'
          this.state.paymentMethod === 'Bank Transfer' &&
          (this.state.selectedFee === 'International Trainee(UAE)' || this.state.selectedFee === '원로회원·기부자·만 70세이상 정회원')
            ? 'Complete'
            : 'Wait';
        param['regType'] = this.state.registrationType === 'early' ? 'R1' : 'R2';
        // param['regType'] = this.state.registrationType === 'early' ? 'R1' : this.state.registrationType === 'regular' ? 'R2' : 'R3';
        param['cate1'] = this.state.selectedFee;
      }

      if (
        method === 'bank' &&
        //   this.state.selectedFee !== 'International Trainee(UAE)'
        this.state.selectedFee !== 'International Trainee(UAE)'
      ) {
        param['depositor'] = this.state.remitterName;
        param['depositDate'] = this.state.remittanceDate;
        // if (this.state.isExtraCharge) {
        //   param['extraDepositor'] = this.state.remitterName;
        //   param['extraDepositDate'] = this.state.remittanceDate;
        // } else {
        //   param['depositor'] = this.state.remitterName;
        //   param['depositDate'] = this.state.remittanceDate;
        // }
      }
      if (method === 'card' && response) {
        if (this.state.isExtraCharge) {
          param['extraPayInfo'] = response;
        } else {
          param['payInfo'] = response;
        }
      }
    }
    // console.log('파라미터: ', param);

    axiosInstance.put(`${WEB_API}/user/registration`, param).then((res) => {
      const swalTitle = this.state.language === 'korean' ? '등록완료' : 'Submission Succeed';
      let swalContentBank =
        this.state.language === 'korean'
          ? `${moment(this.state.remittanceDate).format('YYYY년 M월 D일')}까지 송금을 완료해주시기 바랍니다.`
          : `Please remit the fee by ${moment(this.state.remittanceDate).format('YYYY-M-D')}`;
      const swalContentCard = this.state.language === 'korean' ? 'Your payment has been successful.' : '';

      // 무료등록자 0인 경우 처리
      if (param.amount === 0) swalContentBank = '';

      if (!this.props.isAdmin) {
        if (!this.state.isExtraCharge) {
          if (this.state.isFree && param.amount === 0) {
            // 결제완료메일
            // axiosInstance
            //   .post(
            //     `${WEB_API}/user/payCompleteEmail?evt=${EVENT_ID}&userId=${
            //       param.userId
            //       // }&templateName=${PAYCOMPLETE_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`,
            //     }&templateName=${PAYCOMPLETE_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`,
            //   )
            //   .then((response) => {});
          } else {
            if (method && method !== 'card') {
              // 등록완료메일
              //   axiosInstance
              //     .post(
              //       `${WEB_API}/user/registrationSubmitEmail?evt=${EVENT_ID}&userId=${
              //         param.userId
              //         // }&templateName=${REGISTRAIONSUBMIT_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`,
              //       }&templateName=${REGISTRAIONSUBMIT_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL_REG.toString()}`,
              //     )
              //     .then((response) => {});
            }
          }
        }

        if (method === 'card' && response) {
          // 결제완료메일
          //   axiosInstance
          //     .post(
          //       `${WEB_API}/user/payCompleteEmail?evt=${EVENT_ID}&userId=${
          //         param.userId
          //       }&templateName=${PAYCOMPLETE_TEMPLATE}&from=${F_EMAIL}&bcc=${BCC_ADDR_EMAIL.toString()}`,
          //     )
          //     .then((response) => {});
        }
      }

      swal(swalTitle, method === 'card' ? swalContentCard : swalContentBank, 'success').then(() => {
        this.setInitialize().then(() => {
          if (this.props.isAdmin) {
            this.props.handleClose();
          } else {
            this.props.movePage('/mypage');
          }
        });
      });
    });
  };

  setInitialize = async () => {
    for (const [key, value] of Object.entries(this.state)) {
      if (key !== 'now') {
        if (
          key !== 'isMemberChecked' &&
          key !== 'isMember' &&
          key !== 'registrationFee' &&
          key !== 'annualFee' &&
          key !== 'journalApplicaitonFee' &&
          key !== 'isAgree' &&
          key !== 'isShowCalendar'
        ) {
          await this.setState({ [key]: '' });
        } else {
          if (key === 'registrationFee' || key === 'annualFee' || key === 'journalApplicaitonFee') await this.setState({ [key]: 0 });
          else await this.setState({ [key]: false });
        }
      }
    }
  };

  // 등록구분표 렌더링
  renderRegistration() {
    let KR_FEE = this.state.registrationType === 'early' ? EARLY_REGISTRATION_FEE : REGULAR_REGISTRATION_FEE;
    let OVERSEA_FEE = this.state.registrationType === 'early' ? OVERSEA_EARLY_REGISTRATION_FEE : OVERSEA_REGULAR_REGISTRATION_FEE;

    if (this.state.registrationType === 'onsite') {
      KR_FEE = ONSITE_REGISTRATION_FEE;
      OVERSEA_FEE = OVERSEA_ONSITE_REGISTRATION_FEE;
    }

    if (this.state.language === 'korean') {
      if (this.state.isFree) {
        if (KR_FEE.findIndex((value) => value.category === '원로회원·기부자·만 70세이상 정회원') === -1) {
          KR_FEE.push({ category: '원로회원·기부자·만 70세이상 정회원', fee: 0 });
        }
      }
      return (
        <>
          {KR_FEE.map((item, idx) => {
            return (
              <TableRow key={`early-reg-${idx}`}>
                <StyledTableCell>{item.category}</StyledTableCell>
                <StyledTableCell
                  style={
                    item.category.indexOf('원로회원·기부자·만 70세이상 정회원') !== -1
                      ? { display: 'flex', justifyContent: 'center', alignItems: 'center' }
                      : {}
                  }
                >
                  <Radio
                    color="primary"
                    value={item.category.indexOf('원로회원·기부자·만 70세이상 정회원') !== -1 ? '' : `${item.category}`}
                    id={`title-${idx + 1}`}
                    // disabled={this.props.isAdmin ? false : !this.state.isMember || this.state.isMemberChecked ? true : false}
                    disabled={this.props.isAdmin ? false : this.state.selectedFee === '원로회원·기부자·만 70세이상 정회원'}
                    checked={this.state.selectedFee === `${item.category}`}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        selectedFee: item.category,
                        registrationFee: item.fee,
                      }));
                    }}
                  />
                  KRW {addComma(item.fee)}
                  {item.category.indexOf('원로회원·기부자·만 70세이상 정회원') !== -1 && (
                    <span style={{ color: 'red', marginLeft: '0.5em' }}>※결제방법은 Bank Transfer로 선택하여 주시기 바랍니다.</span>
                  )}
                </StyledTableCell>
              </TableRow>
            );
          })}
        </>
      );
    } else {
      return (
        <>
          {OVERSEA_FEE.map((item, idx) => {
            let dis = false;
            // ** 2022 CUSTOM KSPRS International Member는 모두 선택 불가능하게
            if (item.category.indexOf('KSPRS International') !== -1) dis = true;

            // ** 2022 CUSTOM Physicians of Guest Nations Society 는 UAE 만 선택 가능하게
            if (item.category.indexOf('Physicians of Guest Nations Society') !== -1) dis = this.state.isUAE === true ? false : true;

            // ** 2022 CUSTOM UAE 는 Physicians of Guest Nations Society 만 선택 가능
            if (this.state.isUAE === true) {
              if (
                item.category === 'KSPRS International Member' ||
                item.category === 'Guest Physicians' ||
                item.category === 'International Trainee'
              )
                dis = true;
            }

            // ** 2022 CUSTOM MOU 7개 국가에 대한 선택 제한
            if (this.state.isMou) {
              if (
                item.category === 'Guest Physicians' ||
                item.category === 'Non-Member Physicians' ||
                item.category === 'Physicians of Guest Nations Society'
              )
                dis = true;
            } else {
              if (item.category.indexOf('KSPRS Global') !== -1) dis = true;
            }
            if (this.state.isExtraCharge) dis = true;
            if (this.state.invitedSpeakerCheck) dis = true;
            if (this.props.isAdmin) dis = false;

            if (item.category !== 'Invited Speaker' || this.state.invitedSpeakerCheck === true) {
              return (
                <TableRow
                  key={`early-reg-${idx}`}
                  // UAE 가입자는 금액이 다른 International Trainee 가 보여야 함.
                  style={{
                    display:
                      (item.category == 'International Trainee(UAE)' && this.state.isUAE === false) ||
                      (item.category == 'International Trainee' && this.state.isUAE === true)
                        ? 'none'
                        : '',
                  }}
                >
                  <StyledTableCell>
                    {/* {item.category} */}
                    <div
                      dangerouslySetInnerHTML={{
                        __html: item.category.replace('(', '<br/>(').replace('Society', 'Society<br/>(UAE)'),
                      }}
                    />
                  </StyledTableCell>
                  <StyledTableCell>
                    <Radio
                      name={item.category}
                      color="primary"
                      value={`${item.category}`}
                      id={`title-${idx + 1}`}
                      disabled={dis}
                      checked={this.state.selectedFee === `${item.category}`}
                      onChange={(e) => {
                        this.handleFee(e, item);
                      }}
                    />
                    {addComma(item.fee) === 'Free' ? addComma(item.fee) : `USD ${addComma(item.fee)}`}
                  </StyledTableCell>
                </TableRow>
              );
            }
          })}
        </>
      );
    }
  }

  // 조기등록 이후 등록 구분표 렌더링
  // renderRegularRegistration() {
  //   if (this.state.language === 'korean') {
  //     if (this.state.isFree) {
  //       if (REGULAR_REGISTRATION_FEE.findIndex((value) => value.category === '무료등록') === -1) {
  //         REGULAR_REGISTRATION_FEE.push({ category: '무료등록', fee: 0 });
  //       }
  //     }
  //     return (
  //       <>
  //         {REGULAR_REGISTRATION_FEE.map((item, idx) => (
  //           <TableRow key={`early-reg-${idx}`}>
  //             <TableCell>{item.category}</TableCell>
  //             <TableCell colSpan={2}>
  //               <Radio
  //                 color="primary"
  //                 value={`${item.category}`}
  //                 disabled={this.state.isMemberChecked ? true : false}
  //                 checked={this.state.selectedFee === `${item.category}`}
  //                 onChange={(e) => {
  //                   this.setState({ selectedFee: e.target.value, registrationFee: item.member });
  //                 }}
  //               />
  //               KRW {addComma(item.fee)}
  //             </TableCell>
  //           </TableRow>
  //         ))}
  //       </>
  //     );
  //   } else {
  //     return (
  //       <>
  //         {OVERSEA_REGULAR_REGISTRATION_FEE.map((item, idx) => (
  //           <TableRow key={`early-reg-${idx}`}>
  //             <TableCell>{item.category}</TableCell>
  //             <TableCell>
  //               <Radio
  //                 color="primary"
  //                 value={`${item.category}`}
  //                 id={`title-${idx + 1}`}
  //                 disabled={this.state.selectedFee ? true : false}
  //                 checked={this.state.selectedFee === `${item.category}`}
  //                 onChange={(e) => {
  //                   this.setState({ selectedFee: e.target.value, registrationFee: item.fee });
  //                 }}
  //               />
  //               USD {addComma(item.fee)}
  //             </TableCell>
  //           </TableRow>
  //         ))}
  //       </>
  //     );
  //   }
  // }

  // 전공의 년차 선택 렌더링
  renderResident() {
    return (
      <TableRow>
        <TableCell>전공의 년차 선택</TableCell>
        <TableCell>
          {RESIDENT_TABLE.map((r, idx) => (
            <span key={'resident_' + idx}>
              <Radio
                color="primary"
                value={`${r.value}`}
                id={`resident-${idx + 1}`}
                checked={this.state.residentType === `${r.value}`}
                onChange={(e) => {
                  this.setState({ residentType: r.value });
                }}
              />
              {r.title}
            </span>
          ))}
        </TableCell>
      </TableRow>
    );
  }

  // 국제학회 연회비 납부 표 렌더링
  renderAnnualFee() {
    const { classes } = this.props;

    return (
      <div>
        <Table>
          <TableHead className={classes.tableBorder}>
            <TableRow>
              <StyledTableCell colSpan={2}>국제학회(ICOPLAST) 연회비 납부</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledTableCell component={'th'} width={'30%'} align={'center'}>
                국제학회(ICOPLAST) 연회비
              </StyledTableCell>
              <StyledTableCell width={'70%'} align={'center'}>
                <Checkbox
                  color="primary"
                  checked={this.state.isAnnualChecked}
                  value={this.state.freeIco === true ? 0 : 15000}
                  disabled={this.state.selectedFee !== '전문의' && this.state.selectedFee !== '군의관・공보의'}
                  onChange={(e) => {
                    if (e.target.checked) this.setState({ isAnnualChecked: true, annualFee: this.state.freeIco === true ? 0 : 15000 });
                    else this.setState({ isAnnualChecked: false, annualFee: 0 });
                  }}
                  // size={'large'}
                />
                {this.state.freeIco === true ? 'KRW 0' : 'KRW 15,000'}
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
        <div style={{ color: '#f00', fontWeight: 'bold', paddingTop: 16, fontSize: '1.3em' }}>* 연회비 납부는 전문의에 해당합니다.</div>
        <Grid container alignItems="center" style={{ marginTop: '1em' }}>
          <Grid item xs={2} style={{ textAlign: 'center' }}>
            <img
              src={`${EVENT_IMG}/registration/logo_icp.png`}
              alt=""
              style={{ width: '90%', boxShadow: '1px 1px 3px 1px #dadce0', borderRadius: '3px' }}
            />
          </Grid>
          <Grid item xs={10} style={{ display: 'flex', flexDirection: 'column' }}>
            <Stack direction="column" style={{ paddingLeft: 16 }}>
              <p style={{ fontWeight: 'bold', fontSize: '1.3em', marginBottom: '0.5em' }}>ICOPLAST 연회비 납부</p>
              <p style={{ fontSize: '1.3em' }}>
                우리 학회는 ICOPLAST(INTERNATIONAL CONFEDERATION OF PLASTIC SURGERY SOCIETIES) 상임이사국으로서 <br />
                대한성형외과학회의 정회원은 ICOPLAST의 회원자격을 가지고 있으며 회비납부의 의무를 가지고 있습니다.
              </p>
            </Stack>
          </Grid>
        </Grid>
      </div>
    );
  }

  // 학회지 신청 표 렌더링
  renderJournalApplication() {
    const { classes } = this.props;

    return (
      <div>
        <Table>
          <TableHead className={classes.tableBorder}>
            <TableRow>
              <StyledTableCell colSpan={2}>학회지 (APS) 발전기금 납부</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <StyledTableCell component={'th'} width={'30%'} align={'center'}>
                학회지 발전기금
              </StyledTableCell>
              <StyledTableCell width={'70%'} align={'center'}>
                <Checkbox
                  color="primary"
                  checked={this.state.isJournalChecked}
                  value={this.state.freeAps === true ? 0 : 20000}
                  onChange={(e) => {
                    if (e.target.checked)
                      this.setState({ isJournalChecked: true, journalApplicaitonFee: this.state.freeAps === true ? 0 : 20000 });
                    else this.setState({ isJournalChecked: false, journalApplicaitonFee: 0 });
                  }}
                />

                {this.state.freeAps === true ? 'KRW 0' : 'KRW 20,000'}
              </StyledTableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Grid container style={{ marginTop: '1em' }}>
          <Grid item xs={2} style={{ textAlign: 'center' }}>
            <img
              src={`${EVENT_IMG}/registration/aps_logo.png`}
              alt=""
              style={{ width: '60%', boxShadow: '1px 1px 3px 1px #dadce0', borderRadius: '3px' }}
            />
          </Grid>
          <Grid item xs={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Stack direction="column" style={{ paddingLeft: 16 }}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5em', fontSize: '1.3em' }}>
                학회지 (Archives of Plastic Surgery) 발전기금 납부
              </p>
              <p style={{ fontSize: '1.3em' }}>
                학회지 (Archives of Plastic Surgery) 발전을 위해 유용하게 쓰일 발전기금 20,000원을 받고 있습니다.
                <br /> 납부하신 발전기금은 양질의 학회지로의 발전을 위하여 유용하게 쓰이고 있사오니, 회원 여러분의 적극적인 관심을 부탁
                드립니다.
              </p>
            </Stack>
          </Grid>
        </Grid>
      </div>
    );
  }

  renderPayment() {
    const { classes } = this.props;
    const { language } = this.state;
    const currency = language === 'korean' ? 'KRW' : 'USD';
    return (
      <Table>
        <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
          <TableRow>
            <StyledTableCell component={'th'} width={'25%'}>
              {language === 'korean' ? '합계' : 'Total Amount'}
            </StyledTableCell>
            <StyledTableCell colSpan={2}>
              {this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee > 0
                ? currency + ' ' + addComma(this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee)
                : '-'}
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <StyledTableCell component={'th'} width={'25%'}>
              {language === 'korean' ? '결제수단' : 'Payment Method'}
            </StyledTableCell>
            <StyledTableCell width={'37.5%'}>
              <Radio
                color="primary"
                value="Credit Card"
                checked={this.state.paymentMethod === 'Credit Card'}
                onChange={(e) => this.handleState(e, 'paymentMethod')}
                style={{ padding: '0 9px' }}
                // disabled={language !== 'korean' ? true : false}
              />
              Credit Card&nbsp;
              {/* {language !== 'korean' && '등록기준 미정(사용불가)'} */}
              {language !== 'korean' && <p style={{ color: '#f00' }}>※ Only Master, Visa, Amex and JCB are acceptable.</p>}
            </StyledTableCell>
            <StyledTableCell width={'37.5%'}>
              <Radio
                // disabled={!moment('2021-11-12').isAfter(moment().tz('Asia/Seoul')) ? true : false}
                color="primary"
                value="Bank Transfer"
                checked={this.state.paymentMethod === 'Bank Transfer'}
                onChange={(e) => this.handleState(e, 'paymentMethod')}
                style={{ padding: '0 9px' }}
                inputRef={this.refPaymentMethod}
              />
              Bank Transfer
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderDinner() {
    const { classes } = this.props;
    const { language } = this.state;
    const currency = language === 'korean' ? 'KRW' : 'USD';
    return (
      <Table>
        <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
          <TableRow id={'dinner'}>
            <StyledTableCell component={'th'} width={'62.5%'}>
              {language === 'korean' ? 'Gala Dinner 참석 (KRW 30,000)' : 'Gala Dinner Attendance (USD 30)'}
            </StyledTableCell>

            <StyledTableCell width={'18.75%'}>
              <Radio
                color="primary"
                value={'O'}
                checked={this.state.isDinnerPaid === 'O'}
                onChange={(e) => {
                  this.setState({ dinnerFee: language === 'korean' ? 30000 : 30, isDinnerPaid: 'O' });
                }}
              />
              {language === 'korean' ? '참석' : 'Attend'}
            </StyledTableCell>
            <StyledTableCell width={'18.75%'}>
              <Radio
                color="primary"
                value={'X'}
                checked={this.state.isDinnerPaid === 'X'}
                onChange={(e) => {
                  this.setState({ dinnerFee: 0, isDinnerPaid: 'X' });
                }}
              />
              {language === 'korean' ? '미참석' : 'Not Attend'}
            </StyledTableCell>
          </TableRow>
          <TableRow>
            <TableCell colSpan={3}>
              <Typography style={{ color: 'red' }}>
                {language === 'korean'
                  ? '  ※ 11월 12일(토) 19:00부터 그랜드볼룸(1+2+3)에서 갈라디너가 진행될 예정이오니 많은 참여 부탁 드립니다.'
                  : ' ※ Gala Dinner will be held at the Grand Ballroom(1+2+3) from 19:00 on November 12. '}
              </Typography>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  renderBankTransfer() {
    const { classes } = this.props;
    const { language } = this.state;

    return (
      <>
        {this.spacing(10)}
        <Grid item xs={this.props.isAdmin ? 11 : 8}>
          <Table>
            <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter}`}>
              <TableRow>
                <StyledTableCell component={'th'} width={'25%'}>
                  {language === 'korean' ? '은행명' : 'Bank Name'}
                </StyledTableCell>
                <StyledTableCell width={'75%'}>{language === 'korean' ? '하나은행' : 'Hana Bank'}</StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'} width={'25%'}>
                  {language === 'korean' ? '계좌명' : 'Beneficiary Account'}
                </StyledTableCell>
                <StyledTableCell width={'75%'}>
                  {language === 'korean' ? '대한성형외과학회' : 'Korean Society of Plastic and Reconstructive Surgeons (KSPRS)'}
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'} width={'25%'}>
                  {language === 'korean' ? '계좌번호' : 'Account Number'}
                </StyledTableCell>
                <StyledTableCell width={'75%'}>{language === 'korean' ? '261-910022-59704' : '224-910007-31232'}</StyledTableCell>
              </TableRow>
              {language !== 'korean' && (
                <>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'25%'}>
                      Swift Code
                    </StyledTableCell>
                    <StyledTableCell width={'75%'}>KOEXKRSE or KOEXKRSEXXX</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'25%'}>
                      Branch Name
                    </StyledTableCell>
                    <StyledTableCell width={'75%'}>Seochonam Banking Center</StyledTableCell>
                  </TableRow>
                  <TableRow>
                    <StyledTableCell component={'th'} width={'25%'}>
                      Bank Address
                    </StyledTableCell>
                    <StyledTableCell width={'75%'}>06733, Seoun-ro 3, Seocho-gu, Seoul</StyledTableCell>
                  </TableRow>
                </>
              )}
              <TableRow>
                <StyledTableCell component={'th'} width={'25%'}>
                  {language === 'korean' ? '송금자명' : `Registrant's name`}
                </StyledTableCell>
                <StyledTableCell width={'75%'}>
                  <TextField
                    variant={'outlined'}
                    type={'text'}
                    size={'small'}
                    value={this.state.remitterName}
                    onChange={(e) => this.handleState(e, 'remitterName')}
                    inputRef={this.refRemitterName}
                    style={{ width: '50%' }}
                  />
                </StyledTableCell>
              </TableRow>
              <TableRow>
                <StyledTableCell component={'th'}>{language === 'korean' ? '송금예정일' : 'Remittance Due Date'}</StyledTableCell>
                <StyledTableCell width={'75%'}>
                  <TextField
                    InputProps={{
                      readOnly: true,
                    }}
                    variant={'outlined'}
                    type={'text'}
                    size={'small'}
                    value={this.state.remittanceDate === '' ? '' : moment(this.state.remittanceDate).format('YYYY-MM-DD')}
                    onClick={() => {
                      this.setState((prevState) => ({ isShowCalendar: !prevState.isShowCalendar }));
                    }}
                    inputRef={this.refRemittanceDate}
                    style={{ width: '50%' }}
                  />
                  {this.state.isShowCalendar && (
                    <div>
                      <Calendar locale={language === 'korean' ? 'ko' : 'en'} onChange={this.handleDate} />
                    </div>
                  )}
                </StyledTableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>
      </>
    );
  }

  renderPaymentDetail() {
    const { classes } = this.props;
    const { registrationFee, annualFee, journalApplicaitonFee } = this.state;

    return (
      <Table>
        <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
          <TableRow>
            <StyledTableCell component={'th'} width={'25%'}>
              등록비
            </StyledTableCell>
            <StyledTableCell>
              {this.state.language === 'korean' ? <span>KRW&nbsp;</span> : ''}

              {('' + registrationFee).replace(regexp, ',')}
            </StyledTableCell>
          </TableRow>
          {!this.state.isAnnualPaid && (
            <TableRow>
              <StyledTableCell component={'th'} width={'25%'}>
                국제학회(ICOPLAST) 연회비
              </StyledTableCell>
              <StyledTableCell>
                {this.state.language === 'korean' ? <span>KRW&nbsp;</span> : ''}
                {('' + annualFee).replace(regexp, ',')}
              </StyledTableCell>
            </TableRow>
          )}
          {!this.state.isJournalPaid && (
            <TableRow>
              <StyledTableCell component={'th'} width={'25%'}>
                학회지 (APS) 발전기금
              </StyledTableCell>

              <StyledTableCell>
                {this.state.language === 'korean' ? <span>KRW&nbsp;</span> : ''}
                {('' + journalApplicaitonFee).replace(regexp, ',')}
              </StyledTableCell>
            </TableRow>
          )}
          {/* {this.state.isDinnerPaid === 'O' && (
            <TableRow>
              <StyledTableCell component={'th'} width={'25%'}>
                Gala Dinner
              </StyledTableCell>

              <StyledTableCell>
                {this.state.language === 'korean' ? <span>KRW&nbsp;</span> : ''}
                {('' + dinnerFee).replace(regexp, ',')}
              </StyledTableCell>
            </TableRow>
          )} */}

          <TableRow>
            <StyledTableCell component={'th'} width={'25%'}>
              실 입금액
            </StyledTableCell>
            <StyledTableCell>
              {this.state.language === 'korean' ? <span>KRW&nbsp;</span> : ''}
              {('' + (registrationFee + annualFee + journalApplicaitonFee)).replace(regexp, ',')}
            </StyledTableCell>
          </TableRow>
        </TableBody>
      </Table>
    );
  }

  spacing = (height) => {
    return (
      <Grid item xs={8}>
        <div style={height ? { height: `${height}px` } : { height: '20px' }} />
      </Grid>
    );
  };

  // UAE 국적 등록관련 함수
  //이미지 첨부 버튼 클릭
  clickUploadImg(event, type) {
    event.preventDefault();
    document.getElementById(`${type}`).click();
  }

  //input 태그 -> 실제로 이미지 바꾸는 코드
  handleChangeImg = async (event, type) => {
    this.setState({ attachLoading: true });
    if (event.target.files[0]) {
      let buff = this.state.figures;
      const targetFile = event.target.files[0];
      await readFile(targetFile, -1).then((file) => {
        for (let i = 0; i < buff.length; i++) {
          if (Number(type) === i) {
            buff[i] = targetFile;
          }
        }

        const userName = sessionStorage.getItem('_in_user_');
        const fileFormData = new FormData();
        fileFormData.append('evt', EVENT_ID);

        let idx = 0;
        let maxFile = 0;
        return new Promise(async (resolve, reject) => {
          await UploadToS3Alt(this.state.figures[0], 'PRS2022/attach', userName, 'attachment').then((upload) => {
            fileFormData.append(`attachment_DUP`, JSON.stringify(upload));
            idx++;
            if (idx === maxFile) {
              resolve(fileFormData);
            }
            this.setState({ attachLoading: false, figures: buff, isTraineeDoc: true });
          });
        });
        // this.setState({ figures: buff, isTraineeDoc: true });
      });
    }
  };

  deleteImg(_id, delItem) {
    // ** 2022 CUSTOM
    // 1.해당행사에서는 첨부 리셋용도로만 제공
    // 2.재첨부시에는 동일 파일명 덮어쓰기
    this.setState({ figures: [''] });
    if (this.state.isTraineeDoc && this.state.isTraineeDoc === true) {
      this.setState({ isTraineeDoc: false });
    }
  }

  render() {
    const { classes, theme } = this.props;
    const { language, registrationType } = this.state;
    // console.log(this.state.registrationFee + this.state.annualFee + this.state.journalApplicaitonFee, 'fee');
    // console.log(this.state.isFree, 'free');
    console.log(this.state.selectedFee, 'this.state.selectedFee');
    return (
      <>
        <Grid style={this.props.isAdmin ? { padding: 20 } : { padding: 0 }} container justifyContent={'center'}>
          <Grid item xs={this.props.isAdmin ? 11 : 8}>
            <SubTitle>Registration Fee</SubTitle>
          </Grid>
          {/* {language === 'korean' ? (
          <>
            <Grid item xs={8}>
              <Table>
                <TableBody className={classes.tableBody1}>
                  <TableRow>
                    <TableCell component={'th'}>회원구분 인증</TableCell>
                    <TableCell colSpan={5}>
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                        이름:&nbsp;
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="이름을 입력해주세요"
                          value={this.state.name}
                          onChange={(e) => this.handleState(e, 'name')}
                          inputRef={this.refMemberName}
                        />
                        &nbsp;&nbsp;&nbsp;의사면허번호:&nbsp;
                        <TextField
                          variant="outlined"
                          size="small"
                          placeholder="의사면허번호를 입력해주세요"
                          value={this.state.licenseNo}
                          onChange={(e) => this.handleState(e, 'licenseNo')}
                          inputRef={this.refLicenseNo}
                          style={{ width: '25%' }}
                        />
                        &nbsp;&nbsp;
                        <Button variant="contained" color="secondary" disableElevation onClick={() => this.checkIsMember()}>
                          인증하기
                        </Button>
                      </div>
                      <div className={classes.infoText}>
                        <p>※ 이름, 의사의사면허번호를 입력 후 인증버튼 클릭해 주세요.</p>
                        <p>※ 대한성형외과의사회에 회원가입이 되어 있으셔야 정회원 등록비로 등록 하실 수 있습니다.</p>
                        <p>
                          ※ 의사회 연회비 미납의 경우 정회원 사전등록이 불가합니다. (수련병원 봉직의, 전임의 제외)
                          <br />
                          미납하신 회원은 대한성형외과의사회 (Tel: 02-514-8252, website:{' '}
                          <a href="http://www.prskorea.co.kr" target="_blank">
                            www.prskorea.co.kr
                          </a>
                          )를 통해 연회비를 납부하시기 바랍니다.
                        </p>
                      </div>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </Grid>
            {this.spacing(30)}
          </>
        ) : null} */}
          <Grid item xs={this.props.isAdmin ? 11 : 8}>
            <Table>
              <TableHead className={classes.tableBorder}>
                <TableRow>
                  <StyledTableCell width={'50%'}>{language === 'korean' ? '등록구분' : 'Category'}</StyledTableCell>
                  <StyledTableCell width={'50%'}>
                    {registrationType === 'early'
                      ? 'Early-Bird Registration (Until September 16, 2022)'
                      : registrationType === 'regular'
                      ? 'Regular Registration (From September 17 to October 31, 2022)'
                      : 'On-site Registration (From November 11~13, 2022)'}
                  </StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody className={`${classes.tableBodyAlignCenter} ${classes.tableBorder}`}>
                {this.renderRegistration()}
                {/*{registrationType === 'early' ? this.renderEarlyRegistration() : this.renderRegularRegistration()}*/}

                {/* **2022 CUSTOM 전공의 연차 선택 삭제 */}
                {/* {this.state.selectedFee.indexOf('전공의') !== -1 ? this.renderResident() : null} */}
              </TableBody>
            </Table>

            {this.state.selectedFee === 'International Trainee(UAE)' && (
              <Grid container stlye={{ marginTop: 24 }} id={'attach'}>
                <DocUploadForm
                  // setOfFigures={this.state.setOfFigures}
                  setOfFigures={1}
                  handleChangeImg={this.handleChangeImg}
                  clickUploadImg={this.clickUploadImg}
                  deleteImg={this.deleteImg.bind(this)}
                  figures={this.state.figures}
                />
              </Grid>
            )}

            {language === 'korean' && (
              <p style={{ color: '#f00', fontWeight: 'bold', paddingTop: 16, fontSize: '1.3em' }}>* 사전등록은 PC에서만 가능합니다.</p>
            )}
          </Grid>
          {language === 'korean' ? (
            <>
              {!this.state.isAnnualPaid && (this.state.selectedFee === '전문의' || this.state.selectedFee === '군의관・공보의') && (
                <>
                  {this.spacing(30)}
                  <Grid item xs={this.props.isAdmin ? 11 : 8}>
                    {this.renderAnnualFee()}
                  </Grid>
                </>
              )}

              {!this.state.isJournalPaid && this.state.selectedFee !== '국내연수 외국인의사' && this.state.selectedFee !== '동반자' && (
                <>
                  {this.spacing(30)}
                  <Grid item xs={this.props.isAdmin ? 11 : 8}>
                    {this.renderJournalApplication()}
                  </Grid>
                </>
              )}
              {/* {!this.state.isPay && (
                <>
                </>
              )} */}
            </>
          ) : null}

          {this.state.selectedFee === 'Physicians of Guest Nations Society' && <Grid></Grid>}
          {this.spacing(30)}
          <Grid item xs={this.props.isAdmin ? 11 : 8}>
            <SubTitle>{language === 'korean' ? '참가자 확인 동의서' : 'Participant Release and License Agreement'}</SubTitle>
            <div>
              <Typography style={{ fontWeight: 'bold', padding: '16px 0', fontSize: '1.3em' }}>
                {language === 'korean'
                  ? '하기 내용을 확인하였으며, 그 내용에 동의합니다.'
                  : 'I have carefully read and fully understood the clauses of the Agreement and agree to the terms of the agreement.'}
              </Typography>
            </div>
            <AgreementDiv>
              <b>(1)&nbsp;{language === 'korean' ? '저작권이 연자에 있을 경우' : 'If the copyright belongs to the Speaker'}</b>
              <br />
              {language === 'korean'
                ? '모든 연자들의 강의에 대한 저작권의 보호를 위해, 이 영상을 무단으로 녹음, 녹화, 캡쳐 및 배포하는 것을 금지합니다.'
                : 'In order to protect the copyright of the speakers lecture file(s), unauthorized audio-recording, video-recording, capturing or distribution of the video(s) is prohibited.'}
              <br />
              <br />
              <b>
                (2)&nbsp;
                {language === 'korean'
                  ? '저작권이 대한성형외과학회에 있을 경우'
                  : 'If the copyright is owned by the Korean Society of Plastic and Reconstructive Surgeons'}
              </b>
              <br />
              {language === 'korean'
                ? '모든 강의에 대한 저작권은 [대한성형외과학회]가 보유하고 있는 바, [대한성형외과학회]의 사전 동의 없이 이 영상을 무단으로 녹음, 녹화, 캡쳐 및 배포하는 것을 금지합니다.'
                : 'Since the copyright of the speaker(s) is owned by the Society, audio-recording, video-recording, capturing or distribution of the materials without prior consent of the Society is prohibited.'}
              <br />
              <br />
              <b>(3)&nbsp;{language === 'korean' ? '참조' : 'Note'}</b>
              <br />
              {language === 'korean'
                ? '위 확인동의서에 사전 동의하는 사람에 한하여, 당 학술대회의 오프라인 참여가 가능하며, 오프라인 참여 시 당 확인동의서를 잘 숙지 및 확인하여 동의 여부를 체크하여 주시고, ‘동의’ 항목에 체크한 사람은 위 확인동의서의 내용에 합의한 것으로 간주됩니다.'
                : 'Only people who give prior consent to the above Agreement are allowed to participate in the conference in person. When participating in person, please carefully read and fully understand each clause of the Agreement and check whether you agree or not. Only people who indicate their agreement by clicking the ‘I agree’ checkbox are deemed to agree to the terms of the above Agreement.'}
            </AgreementDiv>
            <div style={{ textAlign: 'right', paddingTop: '1em' }}>
              <Typography style={{ paddingRight: '1em' }}>{this.state.now.format('YYYY.MM.DD')}</Typography>
              <FormControl>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={this.state.isAgree}
                      onChange={(e) => {
                        this.setState({ isAgree: e.target.checked });
                      }}
                    />
                  }
                  label={language === 'korean' ? '동의합니다.' : 'I Agree.'}
                  inputRef={this.refAgree}
                />
              </FormControl>
            </div>
          </Grid>

          {/* gala dinner 참석 여부 */}
          {/* {this.spacing(30)}
          <Grid item xs={this.props.isAdmin ? 11 : 8}>
            <SubTitle>{language === 'korean' ? 'Gala Dinner 참석' : 'Gala Dinner Attendance'}</SubTitle>
            {this.renderDinner()}
          </Grid> */}

          {this.spacing(30)}
          {!this.state.invitedSpeakerCheck && (
            <Grid item xs={this.props.isAdmin ? 11 : 8}>
              <SubTitle>{language === 'korean' ? '결제방법' : 'Payment Method'}</SubTitle>
              {this.renderPayment()}
            </Grid>
          )}
          {this.state.paymentMethod === 'Bank Transfer' && this.renderBankTransfer()}
          {language === 'korean' ? (
            <>
              {this.spacing(30)}
              <Grid item xs={this.props.isAdmin ? 11 : 8}>
                <SubTitle>결제내역</SubTitle>
                {this.renderPaymentDetail()}
              </Grid>
            </>
          ) : null}
          {this.spacing(50)}
          <Grid item xs={this.props.isAdmin ? 11 : 8}>
            <div className={classes.cancelInfoDiv}>
              <SubTitle>{language === 'korean' ? '등록 취소 및 환불' : 'Cancellation and Refund Policy'}</SubTitle>
              <div style={{ padding: theme.spacing(0, 0, 1), lineHeight: '2em', fontSize: '1.2em' }}>
                {language === 'korean' ? (
                  <>
                    - 등록 취소는 대한성형외과학회로 문의하시기 바랍니다. (Tel.02-3472-4253 || E-mail: kprs@plasticsurgery.or.kr)
                    <br />- 등록 취소시의 환불조건은 다음과 같습니다.
                  </>
                ) : (
                  <>
                    - Only cancellations made in writing will be accepted.
                    <br />
                    - Written requests for cancellation should be sent by email(secretariat.kprs@innon.co.kr).
                    <br />
                    - The Conference will refund registration fees to prepaid participants who cancelled their registration in the amount of
                    the refund based on the date of cancellation.
                    <br />
                    - Refunds will be made by bank transfer after the end of PRS KOREA 2022.
                    <br />- Please refer to the following cutoff dates for cancellation.
                  </>
                )}
              </div>
              {language === 'korean' ? (
                <Table>
                  <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
                    <TableRow style={{}}>
                      <StyledTableCell component={'th'} style={{}}>
                        2022년 10월 31일 (월)까지
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#fff' }}>전액환불 (수수료 참가자 부담)</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell component={'th'} style={{}}>
                        2022년 11월 1일 (화)부터
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#fff' }}>전액 환불 불가</StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              ) : (
                <Table>
                  <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
                    <TableRow>
                      <StyledTableCell component={'th'} rowSpan={2}>
                        Cancellation for Registration
                      </StyledTableCell>
                      <StyledTableCell component={'th'}>Until October 31 (Mon), 2022</StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#fff' }}>Full Refund</StyledTableCell>
                    </TableRow>
                    <TableRow>
                      <StyledTableCell component={'th'}>From November 1 (Tue), 2022</StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#fff' }}>No Refund</StyledTableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              )}
              {language === 'korean' && (
                <p style={{ paddingTop: theme.spacing(2), color: '#f00', fontSize: '1.2em', fontWeight: 'bold' }}>
                  {/* ※ 등록비 환불은 행사 종료 후 일괄 환불 해 드립니다. */}
                </p>
              )}
            </div>
          </Grid>
          {this.props.isAdmin && (
            <Grid
              item
              xs={12}
              style={
                this.props.isAdmin
                  ? navigator.userAgent.indexOf('Trident') !== -1
                    ? { padding: 20, minWidth: '960px' }
                    : { padding: 20 }
                  : { padding: 0 }
              }
            >
              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  marginTop: 40,
                  marginBottom: 20,
                  borderBottom: `2px solid ${this.props.theme.palette.primary.main}`,
                }}
              >
                <Typography className={classes.title} gutterBottom style={{ width: 'auto' }}>
                  Admin Memo
                </Typography>
              </div>
              <TextareaAutosize
                style={{ width: '100%', padding: 20 }}
                minRows={10}
                value={this.state.memo}
                onChange={(e) => this.setState({ memo: e.target.value })}
              />
            </Grid>
          )}
          {this.spacing(50)}
          <Grid item xs={8}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              <ConfirmButton
                onClick={() => {
                  if (this.props.isAdmin) {
                    this.props.handleClose();
                  } else {
                    this.props.movePage();
                  }
                }}
              >
                Cancel
              </ConfirmButton>
              <div style={{ width: '20px' }} />
              <ConfirmButton color="primary" onClick={() => this.onSubmit()}>
                Next
              </ConfirmButton>
            </div>
          </Grid>
          {this.state.openPay ? (
            <Popout url={this.state.openPayUrl} title="PRS2021-PAY" onClosing={this.handleClose} options={{ width: 850, height: 800 }} />
          ) : null}
          {/*<SocketManager onmessage={this.receiveMessage} type={'reg'} />*/}
        </Grid>

        {this.state.attachLoading && (
          <div style={{ position: 'fixed', left: '50%', top: '50%', transform: 'translate(-15%, -50%)', zIndex: 9999 }}>
            <CircularProgress size={100} thickness={3} classes={{ circle: classes.circle }} style={{ opacity: 0.7 }} />
            <svg>
              <linearGradient id="linearColors">
                <stop offset="20%" stopColor={'#237a9d'} />
                <stop offset="80%" stopColor={'#aacb3c'} />
              </linearGradient>
            </svg>
          </div>
        )}
      </>
    );
  }
}

export default withStyles(styles, { withTheme: true })(RegistrationSubmissionForm);
